module.exports = __webpack_public_path__ + "static/media/agile.ec11c080.png";